import React from 'react';
import CSSTransition from 'react-transition-group/CSSTransition';

export function Transition(props) {
  return (
    <CSSTransition {...props} addEndListener={props.timeout ? undefined : addEndListener} />
  );
}

function addEndListener(node, done) {
  node.addEventListener('transitionend', done, false);
}
